module.exports = __webpack_public_path__ + "img/T5-B-rc11.c09eeac9.png";